export default __webpack_public_path__ + "static/media/project3.74b036a7.png";